import { jsx as _jsx } from "react/jsx-runtime";
var Pencil = function Pencil(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7477 3C15.6492 2.99992 15.5516 3.01926 15.4606 3.05689C15.3696 3.09453 15.2868 3.14974 15.2171 3.21936L12.9673 5.46917L4.71802 13.7185C4.65802 13.7791 4.60971 13.8503 4.57553 13.9285C4.56616 13.9491 4.55866 13.9697 4.54928 13.9922C4.53991 14.0147 4.52678 14.0391 4.52116 14.0653L3.02129 20.0648C2.98909 20.1911 2.99037 20.3237 3.025 20.4493C3.05964 20.575 3.12643 20.6895 3.21879 20.7814C3.31115 20.8734 3.42589 20.9397 3.5517 20.9739C3.6775 21.008 3.81003 21.0087 3.93621 20.976L9.93571 19.4761C9.96196 19.4761 9.98445 19.4555 10.0088 19.448L10.0726 19.4217C10.1507 19.3876 10.2219 19.3393 10.2826 19.2793L18.5319 11.03L20.7817 8.78014C20.9209 8.63877 20.9984 8.44798 20.9973 8.24956C20.9973 6.85729 20.4442 5.52204 19.4597 4.53756C18.4752 3.55308 17.14 3 15.7477 3ZM5.06111 18.1037L5.82418 15.0571C6.60865 15.1799 7.3336 15.5495 7.89388 16.1121C8.45416 16.6748 8.82064 17.4012 8.94017 18.1862L5.89355 18.9362C5.822 18.7462 5.71074 18.5736 5.56719 18.4301C5.42364 18.2865 5.2511 18.1753 5.06111 18.1037ZM18.5075 8.93013C18.2524 8.12259 17.8066 7.38836 17.2077 6.78953C16.6089 6.19071 15.8747 5.74489 15.0672 5.48979L16.0458 4.51112C16.9339 4.58409 17.7672 4.96998 18.3972 5.60005C19.0273 6.23011 19.4132 7.06341 19.4862 7.95146L18.5075 8.93013Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default Pencil;